const usd = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0
})

const number = new Intl.NumberFormat('en-US', {
    maximumFractionDigits: 2
})

export const formatUsd = (value: number) => usd.format(Math.round(value))

export const formatNumber = (value: number, decimals = 0) => {
    return new Intl.NumberFormat('en-US', {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals
    }).format(value)
}

export const formatPlain = (value: number) => number.format(value)
